module.exports = __webpack_public_path__ + "img/nickjs.71017f81.png";